<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <form role="form" @submit.prevent="createCertificate">
            <div class="card">
                <div class="card-header pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-grid gap-2 d-flex">
                            <button 
                              @click="compareFakturDN"
                              type="button" 
                              :class="'btn btn-xs btn-primary text-xs m-0 ' + (loading_button_compare ? 'disabled' : '')"
                              v-if="form.faktur_url"
                              >
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_button_compare"></span> Compare E-Faktur with DN
                            </button>
                            <button v-if="!form.faktur_url" type="submit" :class="'btn btn-xs btn-primary text-xs m-0 ' + (loading_save ? 'disabled' : '')">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_save"></span> Save
                            </button>
                            <button type="button" class="btn btn-xs btn-outline-secondary text-xs m-0" @click="$router.go(-1)">Discard</button>
                        </div>
                    </div>
                    <hr/>
                </div>
                <div class="card-body pt-0 min-vh-50">
                    <div class="row">
                        <div class="col-lg-6 col-12 mb-3">
                          <div class="table-responsive">
                            <table class=" px-0" width="100%">
                              <tr class="px-0">
                                <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Vendor Name</label></td>
                                <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ partner_name }}</p></td>
                              </tr>
                              <tr class="px-0">
                                <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Vendor Code</label></td>
                                <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ partner_code }}</p></td>
                              </tr>
                              <tr class="px-0">
                                <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">NPWP</label></td>
                                <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ partner_vat }}</p></td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div class="col-lg-6 col-12" v-if="faktur_consumed && po_consumed">
                          <h2 :class="'text-end text-uppercase ' + (matched ? 'text-success': 'text-danger')">{{ matched ? 'match' : 'unmatch' }}</h2>
                          <div class="mt-2 text-end">
                            <p :class="'mb-0 text-xs ' + (res.status === 'unmatch' ? 'text-danger' : 'text-success')" 
                            v-for="res,i in unmatch_description" :key="i">{{ res.description }}</p>
                          </div>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label>Invoice Number</label>
                        <argon-input v-model="form.invoice_number" type="text" placeholder="Invoice Number" size="sm" isRequired autofocus/>
                        <label>Invoice Date</label>
                        <Datepicker
                            v-model="form.invoice_date" 
                            format="dd MMMM yyyy"
                            class="mb-3"
                            required
                            />
                        <label>Invoice File</label>
                        <input type="file" class="form-control form-control-sm" required="True" ref="invoiceBinary" @change="getInvoiceBinary"/>
                      </div>
                      <div class="col-md-4">
                        <label>Faktur Number</label>
                        <argon-input v-model="form.faktur_number" type="text" placeholder="Faktur Number" size="sm" autofocus/>
                        <label>Faktur Date</label>
                        <Datepicker
                            v-model="form.faktur_date" 
                            format="dd MMMM yyyy"
                            class="mb-3"
                            />
                        <label>E-Faktur File</label>
                        <input type="file" class="form-control form-control-sm" ref="fakturBinary" @change="getFakturBinary"/>
                      </div>
                      <div class="col-md-4">
                        <label>E-Faktur URL</label>
                          <div class="d-grid gap-2 d-flex">
                            <div class="col-md">
                              <argon-input v-model="form.faktur_url" type="textarea" placeholder="Type here..." size="sm" @change="getFakturXML" autofocus/>
                            </div>
                            <template v-if="loading_faktur">
                              <span class="spinner-border spinner-border-sm mt-2" role="status" aria-hidden="true"></span> <span class="mt-2 text-xs">Please wait...</span>
                            </template>
                          </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md">
                        <label>List of Delivery Notes</label>
                        <div class="table-responsive">
                          <table class="table">
                            <thead class="text-xs bg-light">
                              <th class="ps-2 text-center" width="5%">#</th>
                              <th class="ps-2">Project</th>
                              <th class="ps-2">Delivery Notes</th>
                              <th width="10%"></th>
                            </thead>
                            <tbody class="text-xs">
                              <tr v-for="line,i in form.line_ids" :key="line.project_id">
                                <td class="text-center">{{ i+1 }}</td>
                                <td>{{ line.project_name }}</td>
                                <td class="break-column">{{ line.delivery_notes_name.join(', ') }}</td>
                                <td>
                                  <button class="btn btn-xs btn-link text-danger m-0 p-0" @click="deleteDN(i)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <button type="button" class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#deliveryNotes" @click="resetModal()">
                          <i class="fa fa-plus" aria-hidden="true"></i> Add
                        </button>
                      </div>
                    </div>
                    <!-- modal -->
                    <div class="modal fade" id="deliveryNotes" tabindex="-1" aria-labelledby="deliveryNotesLabel" aria-hidden="true">
                      <div class="modal-dialog modal-xl modal-dialog-scrollable">
                        <div class="modal-content">
                          <div class="modal-header">
                            <small class="modal-title" id="deliveryNotesLabel">Delivery Notes</small>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <div class="row">
                              <!-- <div class="col-md-3 col-l2">
                                <label for="example-text-input" class="form-control-label">Project</label>
                                <select v-model="modal.project_id" class="form-select form-select-sm" @change="getDeliveryNotes()">
                                  <option disabled selected value="">Select...</option>
                                  <option 
                                    v-for="project in project_options"
                                    :key="project.id"
                                    :value="project.id"
                                    >{{ project.name }}
                                  </option>
                                </select>
                              </div> -->
                              <div class="col-md-2 col-l2">
                                <label for="name" class="form-control-label">Project</label>
                                <Multiselect
                                  v-model="modal.project_id"
                                  mode="tags"
                                  label="name" 
                                  track-by="name"
                                  :close-on-select="false"
                                  :searchable="true"
                                  :options="options_projects"
                                  :multiple="true" 
                                  :taggable="true"
                                  placeholder = "Project"
                                  @update:model-value="getDeliveryNotes"
                                />
                              </div>
                              <div class="col-md-2 col-12">
                                <label for="example-text-input" class="form-control-label">RFQ/PO Number</label>
                                <input v-model="modal.po_number" 
                                        class="form-control form-control-sm" 
                                        type="text" 
                                        name="po_number" 
                                        id="po_number"
                                        @change="getDeliveryNotes()">
                              </div>
                              <div class="col-md-3 col-12">
                                <label for="example-text-input" class="form-control-label">DN Number (Write Multiple DN)</label>
                                <input v-model="modal.dn_number" 
                                        class="form-control form-control-sm" 
                                        type="text" 
                                        name="dn_number" 
                                        id="dn_number"
                                        @change="getDeliveryNotes()">
                              </div>
                              <div class="col-md-3 col-l2">
                                <label for="name" class="form-control-label">DN Number (Select Multiple DN)</label>
                                <Multiselect
                                  v-model="modal.dn_list"
                                  mode="tags"
                                  label="name" 
                                  track-by="name"
                                  :close-on-select="false"
                                  :searchable="true"
                                  :options="options_dn"
                                  :multiple="true" 
                                  :taggable="true"
                                  placeholder = ""
                                  @update:model-value="getDeliveryNotes"
                                />
                              </div>
                              <div class="col-md-2 col-12">
                                <label for="example-text-input" class="form-control-label">DN Delivery Date</label>
                                <Datepicker
                                  format="dd MMMM yyyy"
                                  v-model="modal.delivery_date"
                                  @update:model-value="getDeliveryNotes"
                                  />
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="col-md">
                                <label for="example-text-input" class="form-control-label">List Delivery Notes</label>
                                <div class="table-responsive">
                                  <table class="table">
                                    <thead class="text-sm bg-light py-0 my-0">
                                      <th class="ps-2" width="2%">
                                        <input type="checkbox" v-model="selectAll">
                                      </th>
                                      <th class="ps-2">PO Number</th>
                                      <th class="ps-2">DN Number</th>
                                      <th class="ps-2">Amount(Rp)</th>
                                      <th class="ps-2">Project</th>
                                    </thead>
                                    <tbody class="text-sm">
                                      <template v-if="delivery_note_options.length > 0">
                                        <tr v-for="dn in delivery_note_options" :key="dn.id">
                                          <td><input v-model="modal.selected" type="checkbox" :value="dn.id" @change="getAmountDN()"></td>
                                          <td>{{ dn.purchase.purchase_number }}</td>
                                          <td>{{ dn.name }}</td>
                                          <td>{{ formatPrice(dn.amount) }}</td>
                                          <td>{{ formatProjectName(dn.project_name) }}</td>
                                        </tr>
                                      </template>
                                    </tbody>
                                    <tfoot>
                                      <tr class="fw-bold text-dark">
                                        <td colspan="4">Total Amount (Selected)</td>
                                        <td v-if="modal.selected != null">Rp. {{ formatPrice(modal.total_amount_dn) }}</td>
                                        <td v-else>Rp. -</td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                                <template v-if="modal.loading_dn">
                                  <div class="text-center">
                                    <span class="spinner-border text-success spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span class="text-xs"> Please wait...</span>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button ref="closeModalDN" type="button" class="btn btn-xs btn-link text-dark" data-bs-dismiss="modal" @click="clear">Close</button>
                            <button type="button" class="btn btn-xs btn-primary" @click="addDN">Add</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-md-4" v-if="po_data">
                        <p class="mb-0">Delivery Notes Summary</p>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td><label class="text-secondary my-0">Total Amount</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ po_data.amount_untaxed ? po_data.amount_untaxed.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">PPN</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ po_data.amount_tax ? po_data.amount_tax.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Total Amount + PPN</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ po_data.amount_total ? po_data.amount_total.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Total Payment</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ po_data.amount_total ? po_data.amount_total.toLocaleString() : '0' }}</p></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-4" v-if="faktur_consumed && !loading_button_compare">
                        <p class="mb-0">E-Faktur Summary</p>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td><label class="text-secondary my-0">Kode Transaksi</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">{{ faktur_xml.kdJenisTransaksi }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">FG Pengganti</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">{{ faktur_xml.fgPengganti }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Faktur Number</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">{{ faktur_xml.nomorFaktur }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Faktur Date</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">{{ faktur_xml.tanggalFaktur }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Total Amount</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ faktur_xml.jumlahDpp ? faktur_xml.jumlahDpp.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">PPN</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ faktur_xml.jumlahPpn ? faktur_xml.jumlahPpn.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Total Amount + PPN</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ faktur_xml.totalAmountPlusPpn ? faktur_xml.totalAmountPlusPpn.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Labor</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ form.labor_amount ? form.labor_amount.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">PPh</label></td>
                              <td><p class="text-sm text-dark font-weight-bold my-0">Rp. {{ form.pph_amount ? form.pph_amount.toLocaleString() : '0' }}</p></td>
                            </tr>
                            <tr>
                              <td><label class="text-secondary my-0">Total Payment</label></td>
                              <td>
                                <p class="text-sm text-dark font-weight-bold my-0">
                                  Rp. {{ (faktur_xml.totalAmountPlusPpn && form.pph_amount) !== undefined 
                                  ? (faktur_xml.totalAmountPlusPpn - form.pph_amount).toLocaleString() 
                                  : '0' }}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-4" v-if="faktur_consumed && !loading_button_compare">
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td width="30%" class="align-top"><label class="text-secondary my-0">PPH</label></td>
                              <td>
                                <div class="row g-1">
                                  <div class="col-md-12">
                                    <div class="form-check">
                                      <input v-model="form.pph_type" 
                                        value="without_pph" 
                                        class="form-check-input" 
                                        type="radio" 
                                        name="pphType" 
                                        id="pphType1"
                                        @change="clearPPh">
                                      <label class="form-check-label text-xs" for="pphType1">
                                        Without PPH
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input 
                                        v-model="form.pph_type" 
                                        value="pph23" 
                                        class="form-check-input" 
                                        type="radio" 
                                        name="pphType" 
                                        id="pphType2"
                                        @change="clearPPh">
                                      <label class="form-check-label text-xs" for="pphType2">
                                        PPh pasal 23
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input 
                                        v-model="form.pph_type" 
                                        value="pph42" 
                                        class="form-check-input" 
                                        type="radio" 
                                        name="pphType" 
                                        id="pphType3"
                                        @change="clearPPh">
                                      <label class="form-check-label text-xs" for="pphType3">
                                        PPh pasal 4 (ayat 2)
                                      </label>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <input v-if="form.pph_type !== 'without_pph'" 
                                      v-model="form.pph_note" 
                                      type="text" 
                                      placeholder="PPh note.."
                                      class="form-control form-control-sm">
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="form.pph_type !== 'without_pph'">
                              <td class="align-top"><label class="text-secondary my-0">Labor</label></td>
                              <td>
                                <div class="row g-1">
                                  <div class="col-md-12">
                                    <div class="form-check">
                                      <input
                                        v-model="form.labor_type"
                                        value="full_dpp"
                                        class="form-check-input"
                                        type="radio"
                                        name="laborType"
                                        id="laborType1"
                                        @change="getLaborAmount">
                                      <label class="form-check-label text-xs" for="laborType1">
                                        Full from DPP
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input
                                        v-model="form.labor_type"
                                        value="service"
                                        class="form-check-input"
                                        type="radio"
                                        name="laborType"
                                        id="laborType2"
                                        @change="getLaborAmount">
                                      <label class="form-check-label text-xs" for="laborType2">
                                        Only from service
                                      </label>
                                    </div>
                                  </div>
                                  <div class="col-md-12" v-if="form.labor_type === 'service'">
                                    <input
                                      v-model="form.labor_amount"
                                      type="number"
                                      class="form-control form-control-sm"
                                      placeholder="Labor amount"
                                      @input="calcPPh()">
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="form.pph_type !== 'without_pph'">
                              <td><label class="text-secondary my-0">Service Type</label></td>
                              <td>
                                <div class="row g-1">
                                  <div class="col-md-12">
                                    <select v-model="form.service_type_id" class="form-select form-select-sm" @change="calcPPh">
                                      <option value="" selected>Select service type...</option>
                                      <option 
                                        v-for="type in service_type_options"
                                        :key="type.id"
                                        :value="type.id">
                                        {{ type.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                </div>
            </div>
          </form>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "certificate-create",
  components: {
    ArgonInput
  },
  data() {
    return {
      loading: false,
      loading_save: false,
      partner_name: localStorage.getItem("name"),
      partner_code: localStorage.getItem("partner_code"),
      partner_vat: localStorage.getItem("partner_vat"),
      loading_faktur: false,
      options_projects: [],
      options_dn: [],
      form: {
        invoice_number: null,
        invoice_date: null,
        invoice_file: null,
        invoice_binary: null,
        faktur_number: null,
        faktur_date: null,
        faktur_file: null,
        faktur_binary: null,
        faktur_url: null,
        pph_type: 'without_pph',
        labor_type: '',
        labor_amount: '',
        pph_amount: '',
        service_type_id: '',
        service_percentage: null,
        pph_note: '',
        delivery_notes: [],
        line_ids: [],
      },
      modal: {
        project_selected: [],
        project_id: null,
        po_number: null,
        dn_number: null, //dn number
        delivery_date: null,
        selected: [],
        loading_dn: false,
        dn_list: [],
        total_amount_dn : null
      },
      project_options: [],
      delivery_note_options: [],
      temp_dn_list: [],
      service_type_options: [],
      faktur_consumed: false,
      faktur_xml: null,
      loading_button_compare: false,
      po_consumed: false,
      po_data: null,
      matched: false, // compare DN (PO) amount with efaktur amount
      unmatch_description: [],
      company_vat: ''
    };
  },
  methods: {
    formatProjectName(val) {
        if (!val) return ''
        if (Array.isArray(val)) return val.join(', ')
        return String(val).replace(/[[\]"]/g, '')
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    clear() {
      this.clearModalVals()
    },
    getAmountDN() {
      var dn_list_selected = null
      var amount_dn = null
      if (this.modal.selected.length > 0){
        dn_list_selected = this.delivery_note_options.filter(x => this.modal.selected.includes(x.id));
        dn_list_selected.forEach(function (dn) {
                    amount_dn += dn.amount;
                });
        this.modal.total_amount_dn = amount_dn
      }
      else {
        this.modal.total_amount_dn = null;
      }
      
    },
    getInvoiceBinary (event) {
      // var fileInput = this.$refs.invoiceBinary
      var file = event.target.files[0]
      // Validasi ukuran file maksimum (misalnya, 5 MB)
      let limit_file = 5;
      const maxSizeInBytes = limit_file * 1024 * 1024; // Konversi MB ke bytes
      if (file.size > maxSizeInBytes) {
        // Tampilkan pesan atau ambil tindakan yang sesuai
        alert(`File size exceeds the maximum allowed size (${limit_file} MB). Please choose a smaller file.`);

        // Kosongkan input file
        this.form.invoice_binary = null;

        // Set nama file ke string kosong
        this.form.invoice_file = '';

        // Kosongkan nilai input file di DOM
        this.$refs.invoiceBinary.value = null;

        return;
      }
      const reader = new FileReader()
      reader.onload = e => { 
        this.form.invoice_binary = e.target.result 
      }
      reader.readAsDataURL(file)
      this.form.invoice_file = event.target.files[0].name
    },
    getFakturBinary (event) {
      var file = event.target.files[0]
      // Validasi ukuran file maksimum (misalnya, 5 MB)
      let limit_file = 5;
      const maxSizeInBytes = limit_file * 1024 * 1024; // Konversi MB ke bytes
      if (file.size > maxSizeInBytes) {
        // Tampilkan pesan atau ambil tindakan yang sesuai
        alert(`File size exceeds the maximum allowed size (${limit_file} MB). Please choose a smaller file.`);

        // Kosongkan input file
        this.form.faktur_binary = null;

        // Set nama file ke string kosong
        this.form.faktur_file = '';

        // Kosongkan nilai input file di DOM
        this.$refs.fakturBinary.value = null;

        return;
      }
      const reader = new FileReader()
      reader.onload = e => { 
        this.form.faktur_binary = e.target.result 
      }
      reader.readAsDataURL(file)
      this.form.faktur_file = event.target.files[0].name
    },
    getFakturXML() {
      let faktur_url = null
      try {
        let http_split = this.form.faktur_url.split('//')
        let url_split = http_split[1].split('/')
        url_split[0] = url_split[0].toLowerCase()
        url_split[1] = url_split[1].toLowerCase()
        url_split[2] = url_split[2].toLowerCase()
        let url_join = url_split.join('/')
        faktur_url = http_split[0] + '//' + url_join;
      } catch {
        this.$notify({
          type: 'error',
          title: 'Warning',
          text: 'URLs is not valid!',
        });
        return false;
      }

      if (!this.form.faktur_url) {
        this.form.faktur_number = null
        this.form.faktur_date = null
        return false
      }
      this.loading_faktur = true
      this.axios
        .post(
          endpoint.CERTIFICATE_FAKTUR,
          {
            faktur_url: faktur_url
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.faktur_xml = response.data.data.faktur;
            this.form.faktur_number = this.faktur_xml.kdJenisTransaksi + this.faktur_xml.fgPengganti + this.faktur_xml.nomorFaktur
            var tglFaktur = response.data.data.faktur.tanggalFaktur.split('/')
            this.form.faktur_date = new Date(tglFaktur[2],tglFaktur[1] - 1,tglFaktur[0])
            this.form.invoice_date = new Date(tglFaktur[2],tglFaktur[1] - 1,tglFaktur[0])
            this.loading_faktur = false
          } else {
            // sys error
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
            this.form.faktur_number = null
            this.form.faktur_date = null
            this.form.faktur_url = null
            this.loading_faktur = false
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Failed',
            text: e.response.data.message,
          });
          this.loading_faktur = false
          this.form.faktur_url = null
        });
    },
    async validationFaktur() {
      if (!this.faktur_xml && !this.po_data) {
        return false
      }
      this.unmatch_description = []
      // if (this.faktur_xml.jumlahDpp === this.po_data.amount_untaxed || (this.faktur_xml.jumlahDpp < this.po_data.amount_untaxed && !(this.faktur_xml.jumlahDpp < 0))) {
      if (Math.abs(this.faktur_xml.jumlahDpp - this.po_data.amount_untaxed) <= 2) {
        this.unmatch_description.push({
          'status': 'match',
          'description': 'DPP is match'
        })
      } else {
        this.unmatch_description.push({
          'status': 'unmatch',
          'description': 'Total amount of DN (delivery notes) must be same as amount of e-faktur dpp'
        })
      }

      // if (this.faktur_xml.jumlahPpn === this.po_data.amount_tax || (this.faktur_xml.jumlahPpn < this.po_data.amount_tax && !(this.faktur_xml.jumlahDpp < 0))) {
      if (Math.abs(this.faktur_xml.jumlahPpn - this.po_data.amount_tax) <= 2) {
        this.unmatch_description.push({
          'status': 'match',
          'description': 'PPN is match'
        });
      } else {
        this.unmatch_description.push({
          'status': 'unmatch',
          'description': "Tax amount doesn't match PPN 11% tax amount of delivery note (DN) summary"
        })
      }

      if (this.faktur_xml.npwpPenjual === localStorage.getItem('partner_vat').replace(/[^\w\s]/gi, '')) {
        this.unmatch_description.push({
          'status': 'match',
          'description': "Vendor's NPWP is match"
        })
      } else {
        this.unmatch_description.push({
          'status': 'unmatch',
          'description': "Vendor's NPWP is not match"
        })
      }

      if ((this.faktur_xml.kdJenisTransaksi + this.faktur_xml.fgPengganti + this.faktur_xml.nomorFaktur) === this.form.faktur_number) {
        this.unmatch_description.push({
          'status': 'match',
          'description': 'Faktur Number is match'
        })
      } else {
        this.unmatch_description.push({
          'status': 'unmatch',
          'description': 'Faktur Number is not match'
        })
      }

      if (this.po_data.purchase_ids.length > 1) {
        this.unmatch_description.push({
          'status': 'unmatch',
          'description': 'You may only choose one PO number'
        })
      }
      if (this.form.faktur_date) {
        const form_faktur_month = this.form.faktur_date.getMonth() >= 9 ? (this.form.faktur_date.getMonth() + 1) : '0' + (this.form.faktur_date.getMonth() + 1)
        const form_faktur_day = this.form.faktur_date.getDate() > 9 ? this.form.faktur_date.getDate() : ('0' + this.form.faktur_date.getDate())
        const form_faktur_date = form_faktur_day + '/' + form_faktur_month + '/' + this.form.faktur_date.getFullYear()
        if (this.faktur_xml.tanggalFaktur === form_faktur_date) {
          this.unmatch_description.push({
            'status': 'match',
            'description': 'Faktur Date is match'
          })
        } else {
          this.unmatch_description.push({
            'status': 'unmatch',
            'description': 'Faktur Date is not match'
          })
        }
      }

      if (this.faktur_xml.npwpLawanTransaksi === this.company_vat.replace(/[^\w\s]/gi, '')) {
        this.unmatch_description.push({
          'status': 'match',
          'description': "Seller's NPWP is match"
        })
      } else {
        this.unmatch_description.push({
          'status': 'unmatch',
          'description': "Seller's NPWP is not same as PT.Sanko Gosei Technology Indonesia's NPWP"
        })
      }

      if (this.unmatch_description.filter(x => x.status === 'unmatch').length === 0) {
        this.matched = true
        return true
      } else {
        this.matched = false
        return false
      }
    },
    compareFakturDN() {
      if (this.form.delivery_notes.length > 0) { //this.form.faktur_url && this.form.delivery_notes.length > 0 && this.form.faktur_date && this.form.faktur_number
        let faktur_url = null
        // try {
        //   let http_split = this.form.faktur_url.split('//')
        //   let url_split = http_split[1].split('/')
        //   url_split[0] = url_split[0].toLowerCase()
        //   url_split[1] = url_split[1].toLowerCase()
        //   url_split[2] = url_split[2].toLowerCase()
        //   let url_join = url_split.join('/')
        //   faktur_url = http_split[0] + '//' + url_join;
        // } catch {
        //   this.$notify({
        //     type: 'error',
        //     title: 'Warning',
        //     text: 'URLs is not valid!',
        //   });
        //   return false;
        // }
        this.loading_button_compare = true
        this.axios
          .post(
            endpoint.CERTIFICATE_COMPARE_EFAKTUR_DN,
            {
              faktur_url: faktur_url,
              delivery_notes: this.form.delivery_notes
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            }
          )
          .then(async (response) => {
            console.log('response compare dn >>>', response)
            if (response.data.response_code === "0000") {
              // this.delivery_note_options = response.data.data;
              this.faktur_xml = response.data.data.faktur
              this.po_data = response.data.data.po_dn
              this.company_vat = response.data.data.company_vat
              // await this.validationFaktur()
              if ((this.po_data && this.po_data.purchase_ids.length) > 1 || !this.po_data) {
                // this.unmatch_description.push({
                //   'status': 'unmatch',
                //   'description': 'You may only choose one PO number'
                // })
                this.$notify({
                  type: 'error',
                  title: 'Failed',
                  text: 'You may only choose one PO number',
                });
                return false
              }

              this.po_consumed = true
              this.faktur_consumed = true
              this.loading_button_compare = false
            } else {
              // sys error
              if (response.data.response_code !== "4000"){
                this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
                });
              } else {
                this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
                });
              }
              this.loading_button_compare = false
            }
          })
          .catch((e) => {
            this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
            this.loading_button_compare = false
          });
        } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Please insert Project, Delivery Notes!',
        });
      }
    },
    getServicePercentage(){
      if (this.form.service_type_id && this.service_type_options.length > 0){
        this.form.service_percentage = this.service_type_options.filter(x => x.id === this.form.service_type_id)[0].percentage
      } else {
        this.form.service_percentage = 0
      }
    },
    clearPPh() {
      if (this.form.pph_type === 'without_pph') {
        this.form.labor_type = ''
        this.form.pph_note = ''
        this.form.service_type_id = ''
        this.form.labor_amount = ''
      }
      this.calcPPh()
    },
    getLaborAmount() {
      this.form.labor_amount = ''
      if (this.form.labor_type === 'full_dpp') {
        this.form.labor_amount = this.faktur_xml.jumlahDpp
      }
      this.calcPPh()
    },
    getPOFromDN (value) {
      this.po_data = null
      this.axios
        .post(
          endpoint.GET_PO_FROM_DN,
          {
            delivery_notes: value
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.po_data = response.data;
          } else {
            // sys error
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Failed',
            text: e.response.data.message,
          });
        });
    },
    calcPPh() {
      this.getServicePercentage()
      var percentage = 0
      if (this.form.pph_type === 'pph23') {
        percentage = 0.02
      } else if (this.form.pph_type === 'pph42') {
        percentage = this.form.service_percentage / 100
      }
      this.form.pph_amount = this.form.labor_amount * percentage
    },
    getServiceType() {
      // TODO: get delivery notes for selection based on partner_id
      this.axios
        .post(
          endpoint.SERVICE_TYPE,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.service_type_options = response.data.data;
          } else {
            // sys error
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Failed',
            text: e.response.data.message,
          });
        });
    },
    addDNOld() {
      var delivery_notes_name = []
      var purchases_name = []
      
      if (this.modal.project_id) {
        // var project_id = this.project_options.find(x => x.id === this.modal.project_id)
        this.modal.selected.forEach(e => {
          var dn_id = this.delivery_note_options.find(x => x.id === e)
          if (dn_id.name) {
            delivery_notes_name.push(dn_id.name)
          }
          if (dn_id.purchase.purchase_number) {
            purchases_name.push(dn_id.purchase.purchase_number)
          }
        });
        this.form.delivery_notes.push(...this.modal.selected)
        this.getPOFromDN(this.form.delivery_notes)
        this.form.line_ids.push({
          'project_name': this.modal.project_id.name,
          'project_id': this.modal.project_id,
          'delivery_notes_ids': this.modal.selected,
          'delivery_notes_name': [...new Set(delivery_notes_name)],
          'purchase_name': [...new Set(purchases_name)]
        })
      } else {
        let project_ids = [];
        let distinctProjectIds = [];

        for (let e of this.modal.selected) {
          var dn_id = this.delivery_note_options.find(x => x.id === e);
          if (dn_id.project_ids) {
            project_ids.push(...dn_id.project_ids);
          }
          if (dn_id.purchase.purchase_number) {
            purchases_name.push(dn_id.purchase.purchase_number);
          }
        }

        distinctProjectIds = [...new Set(project_ids)];

        for (let p of distinctProjectIds) {
          let dn_name = [];
          let po_name = [];
          let dn_ids = [];

          // loop per project
          for (let e of this.modal.selected) {
            var dn = this.delivery_note_options.find(x => x.id === e && x.project_ids.includes(p));
            if(dn){
              if (dn.name) {
                dn_name.push(dn.name);
                dn_ids.push(dn.id);
              }
              if (dn.purchase.purchase_number) {
                po_name.push(dn.purchase.purchase_number);
              }
            }
          }
          var project = this.project_options.find(x => x.id === p)
          let line_ids = {
            'project_name': project.name,
            'project_id': p,
            'delivery_notes_ids': dn_ids,
            'delivery_notes_name': [...new Set(dn_name)],
            'purchase_name': [...new Set(po_name)],
          };
          this.form.line_ids.push(line_ids);
        }
        this.form.delivery_notes.push(...this.modal.selected)
        this.getPOFromDN(this.form.delivery_notes)
      }
      this.$refs.closeModalDN.click();
      this.clearModalVals()
    },
    addDN() {
      var purchases_name = []
      
      let project_ids = [];
      let distinctProjectIds = [];

      for (let e of this.modal.selected) {
        var dn_id = this.delivery_note_options.find(x => x.id === e);
        if (dn_id.project_ids) {
          project_ids.push(...dn_id.project_ids);
        }
        if (dn_id.purchase.purchase_number) {
          purchases_name.push(dn_id.purchase.purchase_number);
        }
      }

      distinctProjectIds = [...new Set(project_ids)];

      for (let p of distinctProjectIds) {
        let dn_name = [];
        let po_name = [];
        let dn_ids = [];

        // loop per project
        for (let e of this.modal.selected) {
          var dn = this.delivery_note_options.find(x => x.id === e && x.project_ids.includes(p));
          if(dn){
            if (dn.name) {
              dn_name.push(dn.name);
              dn_ids.push(dn.id);
            }
            if (dn.purchase.purchase_number) {
              po_name.push(dn.purchase.purchase_number);
            }
          }
        }
        var project = this.project_options.find(x => x.id === p)
        let line_ids = {
          'project_name': project.name,
          'project_id': p,
          'delivery_notes_ids': dn_ids,
          'delivery_notes_name': [...new Set(dn_name)],
          'purchase_name': [...new Set(po_name)],
        };
        this.form.line_ids.push(line_ids);
      }
      this.form.delivery_notes.push(...this.modal.selected)
      this.getPOFromDN(this.form.delivery_notes)
      
      this.$refs.closeModalDN.click();
      this.clearModalVals()
    },
    deleteDN(index) {
      var dn_to_remove = this.form.line_ids[index].delivery_notes_ids
      dn_to_remove.forEach(dn => {
        var dn_index = this.form.delivery_notes.indexOf(dn)
        this.form.delivery_notes.splice(dn_index,1)
      });
      this.form.line_ids.splice(index,1)
      this.getPOFromDN(this.form.delivery_notes)
    },
    clearModalVals() {
      console.log('Clear Modal')
      this.modal.project_id = null
      this.modal.selected = []
      // this.delivery_note_options = []
      this.modal.delivery_date = null
      this.modal.po_number = null
      this.modal.dn_number = null
      this.modal.dn_list = []
      this.modal.total_amount_dn = null
    },
    resetModal() {
      console.log('Clear Modal')
      this.clearModalVals()
      this.getDeliveryNotes()
    },
    getProject() {
      // TODO: get project for selection based on partner_id
      this.axios
        .post(
          endpoint.PROJECT_LIST,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.project_options = response.data.data;
          } else {
            // sys error
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Failed',
            text: e.response.data.message,
          });
        });
    },
    getProjectList() {
            this.loading = true
            this.options_projects = []
            this.axios
            .post(
                    endpoint.PROJECT_SEARCH,
                    {
                    }, //PARAMS
                    {
                        headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                )
                .then((response) => {
                if (response.data.response_code === "0000") {
                    this.options_projects = response.data.data;
                    this.loading = false
                } 
                else {
                    // sys error
                    if (response.data.response_code !== "4000"){
                        this.$notify({
                            type: 'error',
                            title: 'Warning',
                            text: response.data.message
                        });
                        this.loading = false
                    }
                    this.loading = false
                }
                })
                .catch((e) => {
                    this.$notify({
                        type: 'error',
                        title: 'Failed',
                        text: e.response.data.message,
                    });
                    console.log(e)
                    this.loading = false
                });
        },
        getDNSearch() {
            this.loading = true
            this.options_projects = []
            this.axios
            .post(
                    endpoint.DN_LIST_SEARCH,
                    {
                      partner_id: localStorage.getItem("partner_id"),
                      state: ['done']
                    }, //PARAMS
                    {
                        headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                )
                .then((response) => {
                    console.log(response)
                if (response.data.response_code === "0000") {
                    this.options_dn = response.data.data;
                    this.loading = false
                } 
                else {
                    // sys error
                    if (response.data.response_code !== "4000"){
                        this.$notify({
                            type: 'error',
                            title: 'Warning',
                            text: response.data.message
                        });
                        this.loading = false
                    }
                    this.loading = false
                }
                })
                .catch((e) => {
                    this.$notify({
                        type: 'error',
                        title: 'Failed',
                        text: e.response.data.message,
                    });
                    console.log(e)
                    this.loading = false
                });
        },
    filteredDNList () {
      var selectedDNList = []
      this.form.line_ids.forEach(line => {
        line.delivery_notes_ids.forEach(dn => {
          selectedDNList.push(dn)
        });
      });
      return selectedDNList
    },
    getDeliveryNotes() {
      this.modal.loading_dn = true
      // TODO: get delivery notes for selection based on partner_id\
      let dn_number_arr = []
      this.modal.selected = []
      this.delivery_note_options = []
      // this.form.delivery_notes = []
      var delivery_date = null
      if (this.modal.delivery_date){
        const delivery_month = this.modal.delivery_date.getMonth() >= 9 ? (this.modal.delivery_date.getMonth() + 1) : '0' + (this.modal.delivery_date.getMonth() + 1)
        delivery_date = this.modal.delivery_date.getFullYear() + '-' + delivery_month + '-' + this.modal.delivery_date.getDate()
      }

      if (this.modal.dn_number) {
        dn_number_arr = this.modal.dn_number.split(" ")
      } 
      for (let i of this.modal.dn_list) {
        dn_number_arr.push(i)
      }

      this.axios
        .post(
          endpoint.DN_LIST,
          {
            project_ids: this.modal.project_id,
            for_certificate: true,
            partner_id: localStorage.getItem("partner_id"),
            po_number: this.modal.po_number,
            // number: this.modal.dn_number,
            number: dn_number_arr,
            delivery_date: delivery_date,
            state: ['done'],
            limit: 0,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          var selectedDNList = this.filteredDNList()
          if (response.data.response_code === "0000") {
            var availDNList = [];
            availDNList = response.data.data.filter(function(el){
              return !selectedDNList.includes(el.id);
            })
            this.delivery_note_options = availDNList;
            this.modal.loading_dn = false;
            if (!availDNList.length > 0) {
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: 'Data not found',
              });
            }
          } else {
            // sys error
            // if (response.data.response_code !== "4000"){
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
            // }
            this.modal.loading_dn = false
          }
        })
        .catch((e) => {
          this.modal.loading_dn = false;
          this.$notify({
            type: 'error',
            title: 'Failed',
            text: e,
          });
        });
    },
    async createCertificate() {
      if (this.form.line_ids.length === 0) {
        alert('Please select list of DN!')
        return false
      }
      // var checkFaktur = await this.validationFaktur()
      // if (!checkFaktur) {
      //   return false
      // }
      if ((this.po_data && this.po_data.purchase_ids.length) > 1 || !this.po_data) {
        // this.unmatch_description.push({
        //   'status': 'unmatch',
        //   'description': 'You may only choose one PO number'
        // })
        console.log('PO DATA >>>', this.po_data)
        this.$notify({
            type: 'error',
            title: 'Failed',
            text: 'You may only choose one PO number',
          });
        return false;
      }
      this.loading_save = true
      const invoice_month = this.form.invoice_date.getMonth() >= 9 ? (this.form.invoice_date.getMonth() + 1) : '0' + (this.form.invoice_date.getMonth() + 1)
      var faktur_month = null
      if (this.form.faktur_date) {
        faktur_month = this.form.faktur_date.getMonth() >= 9 ? (this.form.faktur_date.getMonth() + 1) : '0' + (this.form.faktur_date.getMonth() + 1)
      }
      const values = {
        "partner_id": localStorage.getItem("partner_id"),
        "invoice_number": this.form.invoice_number,
        "invoice_date": this.form.invoice_date.getFullYear() + '-' + invoice_month + '-' + this.form.invoice_date.getDate(),
        "invoice_file": this.form.invoice_binary.split(',')[1],
        "invoice_file_name": this.form.invoice_file,
        "faktur_number": this.form.faktur_number,
        "kode_transaksi": this.faktur_xml?.kdJenisTransaksi || '',
        "fg_pengganti": this.faktur_xml?.fgPengganti || '',
        "faktur_date": this.form.faktur_date ? (this.form.faktur_date.getFullYear() + '-' + faktur_month + '-' + this.form.faktur_date.getDate()) : null,
        "faktur_file": this.form.faktur_binary ? this.form.faktur_binary.split(',')[1] : '',
        "faktur_file_name": this.form.faktur_file || '',
        "faktur_url": this.form.faktur_url,
        "amount_untaxed": this.faktur_xml?.jumlahDpp || this.po_data.amount_untaxed,
        "amount_ppn": this.faktur_xml?.jumlahPpn || this.po_data.amount_tax,
        "delivery_notes": this.form.delivery_notes,
        "pph_type": this.form.pph_type,
        "labor_type": this.form.labor_type,
        "service_type_id": this.form.service_type_id,
        "amount_pph": this.form.pph_amount,
        "amount_labor": this.form.labor_amount,
        "pph_note": this.form.pph_note,
        "line_ids": this.form.line_ids
      }
      //TODO: when save button clicked, call this method
      this.axios
        .post(
          endpoint.CERTIFICATE_UPSERT,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.$notify({
              type: 'success',
              title: 'Voila!',
              text: 'Successfully create certificate of invoice',
            });
            this.$router.replace('/certificate/' + response.data.data[0].certificate_id)
          } else {
            // sys error
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading_save = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message,
          });
          this.loading_save = false;
        });
    }
  },
  computed: {
    selectAll: {
        get: function () {
          if (this.modal.selected.length > 0) {
            return this.delivery_note_options ? this.modal.selected.length == this.delivery_note_options.length : false;
          }
          return false
        },
        set: function (value) {
            var selected = [];

            if (value) {
                this.delivery_note_options.forEach(function (dn) {
                    selected.push(dn.id);
                });
            }
            this.modal.selected = selected;
            this.getAmountDN();
        }
    }
  },
  mounted() {
    this.getProject();
    this.getServiceType();
    this.getProjectList();
    this.getDNSearch();
    this.getDeliveryNotes();
  }
};
</script>

<style>
  .break-column {
    word-wrap: break-word;
    min-width: 160px;
    max-width: 160px;
    white-space:normal !important;
  }
</style>